import React, { Fragment, useState, useContext } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import { Button, Dialog, Grid } from '@material-ui/core'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { AddCircleOutline } from '@material-ui/icons'
import { Alert } from '@material-ui/lab'
import axios from 'axios'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export default function EnableGestor(props) {
  const classes = useStyles()
  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [severity, setSeverity] = useState('success')
  const [returnLogin, setReturnLogin] = React.useState(false)

  const { urlServices, keyAplication } = useContext(UrlServicesContext)
  let keyAuthorization = localStorage.getItem('Session')

  let data = props.id

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const handleEnable = () => {
    setOpenAlert(false)
    const dataValue = {
      status: 1,
    }

    axios
      .put(`${urlServices}users/${data.id}`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response2) => {
        setMensaje('Registro actualizado con éxito.')
        setSeverity('success')
        setOpenAlert(true)
        props.callBackRefresh()
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setMensaje('Error al registrar!!')
          setSeverity('error')
        }
      })
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers>
          <Grid container>
            {!openAlert ? (
              <>
                <Grid item xs={12} md={12} style={{ paddingTop: 30 }}>
                  <center>
                    <AddCircleOutline style={{ fontSize: 50, color: 'ref' }} />
                    <br></br>
                    <div className={classes.titleCardFilter}>
                      ¿Desea HABILITAR este registro?
                    </div>
                  </center>
                </Grid>
                <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                  <center>
                    <Button
                      className={classes.buttonSubmit2}
                      onClick={handleEnable}
                    >
                      Habilitar
                    </Button>
                  </center>
                </Grid>
              </>
            ) : (
              <Grid item xs={12} md={12}>
                <Alert severity={severity === 'error' ? 'error' : 'success'}>
                  {mensaje}
                </Alert>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialog(true)}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}
